import { objectGetOwnPropertySymbols, objectProtoPropertyIsEnumerable } from './native.js';

function getSymbols(object) {
    if (!objectGetOwnPropertySymbols || object === null) {
        return [];
    }
    return objectGetOwnPropertySymbols(object).filter(function (item) { return objectProtoPropertyIsEnumerable.call(object, item); });
}

export { getSymbols as default };
